import axios from 'axios';
const moment = require('moment');

// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'nomor', 'terimadari', 'kodeacc', 'namaacc', 'kodebank', 'paymethod', 'trxgroup','iogroup', 'poststatus'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/rop${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },bankaccount() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/bankcashacc/allaccount");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },bankacconly() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/bankcashacc/bankaccount");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    byrsemu(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`apinv/byrsemu/${obj.apinvkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    byrsemuAdv(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`advance/byrsemu/${obj.advanKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    byrsemuAdvSet(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`advsettle/byrsemu/${obj.advSttlKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    byrsemuExp(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`expense/byrsemu/${obj.expenKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
    ,paymentdetail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`rop/paymentdetail/${obj.id}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },postingPayment(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`rop/postingpayment/${obj.trbankkey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },postingUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`rop/postingundo/${obj.trbankkey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
    });
    },
    postingBulkBank(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`rop/posting-bulk-bank`,obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    unpostingBulkBank(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`rop/unposting-bulk-bank`,obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.trbankkey);
                url = `/rop/printpayment`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    insert(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await axios.post("rop", obj);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}
,remove(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.delete(`rop/${obj.trbankkey}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
}
,exportxls(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['sortBy', 'sortDir', 'uraian', 'DimCol', 'DimColInfo', 'DimVal', 'tgl1', 'tgl2', 'nomor', 'terimadari', 'kodeacc', 'namaacc', 'kodebank', 'paymethod', 'trxgroup', 'iogroup', 'poststatus'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }

            axios({
                url: `/rop/exportxls${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `request_of_payment_list_${moment().format('YYYYMMDDHHmm')}.xlsx`);
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });

        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
actionhistory(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const { data } = await axios.get(`/rop/actionhistory/${obj.trbankkey}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
approval(formData) {
    return new Promise(async (resolve, reject) => {
        try {
            console.log('File Name : ', formData.filename);
            const { data } = await axios.post("rop/send2wf", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
approvalUndo(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const resp = await axios.put(`/rop/send2wfCancel/${obj.trbankkey}`);
            resolve(resp);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
}

};